import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faGear, faCheck } from "@fortawesome/free-solid-svg-icons";
import { initializeAnalytics } from "./analytics";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [consent, setConsent] = useState(Cookies.get("secureShopCookieConsent") === "true");
  const [preferences, setPreferences] = useState({ necessary: true, analytics: false, marketing: false });
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    const consentCookie = Cookies.get("secureShopCookieConsent");
    const dismissedAt = sessionStorage.getItem("cookieDismissedAt");
    const now = Date.now();

    if (!consentCookie) {
      if (!dismissedAt || now - parseInt(dismissedAt, 10) > 7 * 24 * 60 * 60 * 1000) {
        setVisible(true);
      }
    }
  }, []);

  useEffect(() => {
    if (consent) {
      initializeAnalytics();
    } else {
      sessionStorage.removeItem("GA_initialized");
    }
  }, [consent]);

  const handleAccept = () => {
    setConsent(true);
    Cookies.set("secureShopCookieConsent", true, { expires: 365 });
    setPreferences({ necessary: true, analytics: true, marketing: true });
    setVisible(false);
  };

  const savePreferences = () => {
    Cookies.set("secureShopCookieConsent", JSON.stringify(preferences), { expires: 365 });
    setConsent(preferences.analytics || preferences.marketing);
    setVisible(false);
  };

  const handleDismiss = () => {
    sessionStorage.setItem("cookieDismissedAt", Date.now().toString());
    setVisible(false);
    initializeAnalytics();
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full bg-white text-gray-800 border-t border-gray-300 p-4 z-50 shadow-lg sm:px-6 sm:py-3">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between max-w-6xl mx-auto gap-2">
        <div className="text-xs sm:text-sm">
          <strong>Cookies:</strong> We use cookies to improve your experience. See our <a href="/privacypolicy" className="underline" style={{ color: '#1d275f' }}>Policy</a>.
        </div>
        <div className="grid grid-cols-2 sm:flex gap-2 w-full sm:w-auto">
          <button
            onClick={() => setShowSettings(!showSettings)}
            className="text-xs px-3 py-2 border border-gray-400 rounded-md hover:bg-gray-100 flex items-center justify-center gap-1"
          >
            <FontAwesomeIcon icon={faGear} /> Settings
          </button>
          <button
            onClick={handleAccept}
            className="text-xs px-3 py-2 text-white rounded-md flex items-center justify-center gap-1"
            style={{ backgroundColor: '#1d275f' }}
          >
            <FontAwesomeIcon icon={faCheck} /> Accept
          </button>
        </div>
      </div>

      {showSettings && (
        <div className="mt-3 border-t border-gray-200 pt-3 text-xs sm:text-sm grid grid-cols-2 gap-2">
          <label className="col-span-2">
            <input type="checkbox" checked disabled /> Necessary (Always Active)
          </label>
          <label>
            <input
              type="checkbox"
              checked={preferences.analytics}
              onChange={(e) => setPreferences({ ...preferences, analytics: e.target.checked })}
            /> Analytics
          </label>
          <label>
            <input
              type="checkbox"
              checked={preferences.marketing}
              onChange={(e) => setPreferences({ ...preferences, marketing: e.target.checked })}
            /> Marketing
          </label>
          <button
            onClick={savePreferences}
            className="col-span-2 mt-1 text-xs px-3 py-2 text-white rounded-md hover:opacity-90 flex items-center justify-center gap-1"
            style={{ backgroundColor: '#1d275f' }}
          >
            <FontAwesomeIcon icon={faCheck} /> Save
          </button>
        </div>
      )}

      <button
        onClick={handleDismiss}
        className="absolute top-2 right-4 text-gray-500 hover:text-gray-700"
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
};

export default CookieBanner;